import { useMemo } from "react";
import { IconName } from "lucide-react/dynamic";
import classnames from "classnames";

import { Icon as IconType } from "@/lib/api";
import { Icon } from "@/components/icon/icon";

import styles from "./icon-avatar.module.css";

interface IconAvatarProps {
  className?: string;
  icon: IconName | IconType;
}

const IconAvatar = ({ icon, className }: IconAvatarProps) => {
  const inner = useMemo(() => {
    if (typeof icon === "string") return <Icon name={icon} />;
    if (icon?.type === "symbol") return <Icon name={icon.variant as IconName} />;
    if (icon?.type === "abbreviation") return <span>{icon.content.substring(0, 2)}</span>;
    return <Icon name="file" />;
  }, [icon]);

  return <span className={classnames(styles.icon, className)}>{inner}</span>;
};

export default IconAvatar;
